function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg404V2 = function Svg404V2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 673.79 469.67"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8 267.61a114.4 114.4 0 0 1-3.06-22C41.85 204 64.23 161.39 99.39 139.86c43-26.31 91-7.21 137.1-18.69 28.29-7 51.23-26.71 73.24-44.77 52.77-43.3 152.61-70.67 209.4-8.8 24 26.15 29.06 60.37 45.57 90.54 11.14 20.35 27.37 35.07 43.6 51.11 23.32 23 55 50.71 56.62 86 1 22.73-12.83 43.63-30.1 57.25-54.75 43.16-130 35-190.9 10.64-62.75-25.09-123.41-62.35-193.76-59.81-34.26 1.25-62.87 22.88-96.41 27.8-45.85 6.74-95.49-16.42-106.95-63.52",
    style: {
      fill: "#ffe4e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.46 409.03 39.15 40.81h187.76l-40.82-40.81z",
    style: {
      fill: "none",
      stroke: "#ffb4bc",
      strokeMiterlimit: 10,
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.46 44.49h185.79v364.54H222.46z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.46 44.49h185.42v364.54H222.46z",
    style: {
      fill: "none",
      stroke: "#ffb4bc",
      strokeMiterlimit: 10,
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.03 57.82h160.15v351.21H236.03z",
    style: {
      fill: "#ee4b5d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.25 81.38h48.56v125.47h-48.56zM322.54 81.38h48.56v125.47h-48.56z",
    style: {
      fill: "#352269"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.13 81.38h7.97v125.47h-7.97zM301.84 81.38h7.97v125.47h-7.97z",
    style: {
      fill: "#1b0f49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370.95 81.43-48.56 86.26V81.43zM309.52 81.43l-48.56 86.26V81.43z",
    style: {
      fill: "#dfd8ff",
      opacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.25 214.87h48.56M322.54 214.87h48.56M261.25 236.76h48.56v139.42h-48.56zM322.54 236.76h48.56v139.42h-48.56z",
    style: {
      fill: "none",
      stroke: "#ce414d",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.29,
    cy: 418.31,
    rx: 49.8,
    ry: 10.91,
    style: {
      fill: "#ffe4e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518 431.35h-12.49c-4.66-.07-16.57-1.21-8.26-5.48 2.66-.6 4.12-1.26 4.12-1.94 0-3.26-33.14-5.9-74-5.9s-74 2.64-74 5.9 33.14 5.91 74 5.91h3.59c5.3.78 9.24 3.37 3.73 6a1.3 1.3 0 0 1 .46-.13c-1.76.5-2.69 1-2.72 1.58-.36 5.91 44.71 5.91 85.58 5.91s70-2.65 70-5.91-29.16-5.94-70.01-5.94",
    style: {
      fill: "#ffe4e5",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.4 148s-11.92 50.26-15.23 54.6-12.24-3.52-11.83-7.2 10.76-38.18 12.6-48.08c2.48-13.38 17.06-14.65 14.46.68",
    style: {
      fill: "#ffa49e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.81 196.17s-27.77-50.6-29.3-53.42-4.63-.56-5.8 1.68c-.11 2.42 16.7 54.68 22.31 60.44 8.36 8.58 12.79-8.7 12.79-8.7",
    style: {
      fill: "#ffa49e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.27 134.5s-11.86-1.59-14.33 12.8c-4.13 16.55-6.69 25.85-6.69 25.85a16.66 16.66 0 0 0 14.55 7.07s15.12-37.22 6.47-45.72",
    style: {
      fill: "#d2cdfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.47 214.11-56.16 199.2h-10.35l26.55-199.86z",
    style: {
      fill: "#c4b7fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.73 213.45h-52.22s-4.89-41.63-3.42-56.26c1.49-14.87 6.36-21.69 12.18-22.69a7 7 0 0 1 1.27-.13h37.64a7.12 7.12 0 0 1 7.09 7.84Z",
    style: {
      fill: "#dfd8ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449 137.06a3.87 3.87 0 0 0 .74-3.7c-.91-2.43-1.89-7.32 0-15.41 2.91-12.45 1.46-23.28-12.28-27.65-12.22-3.88-15.75 18.7-12.52 28.75a7.2 7.2 0 0 0 3.74 4.18l1.31.63a3.92 3.92 0 0 1 2.36 3.25c.19 2.44.23 6.27-1 8.15-1.94 2.89-1.58 5.13.13 9.69 6.37-2.07 14.65-4.02 17.52-7.89",
    style: {
      fill: "#ffa49e"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 424.42,
    cy: 107.14,
    rx: 0.61,
    ry: 1.06,
    style: {
      fill: "#352269"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 431.65,
    cy: 107.74,
    rx: 0.61,
    ry: 1.06,
    style: {
      fill: "#352269"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.25 108.13a4.24 4.24 0 0 1-.31 1.87c-.12.24-.28.46-.4.7a2.12 2.12 0 0 0-.19 1.36",
    style: {
      fill: "none",
      stroke: "#ec7d7a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".6000000000000001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.46 412.76-.39 8.59H373s-1.86-.93 4.4-3.35 11.5-3.52 11.65-5.24Z",
    style: {
      fill: "#dfd8ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.8 214.44s5.05 9.05 4.12 25.45-3.68 176.63-3.68 176.63l-9.68-.26L433 213.45Z",
    style: {
      fill: "#c4b7fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452.13 213.45-42 191.09h-21.28l26.66-191.09z",
    style: {
      fill: "#352269"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.94 152.12 30.46 50.94s14.06-2.68 13.15-6.27-22.14-42.71-25.21-52.31c-4.44-13.88-23.09-7.17-18.4 7.64",
    style: {
      fill: "#ffa49e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m439.63 245.79-29.5 158.75 33.08-150.37z",
    style: {
      fill: "#1b0f49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.44 213.45 22.27 191.09h15.05s4.39-149.86 3.8-166.55-4.83-24.54-4.83-24.54Z",
    style: {
      fill: "#352269"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m415.51 213.45-.76 5.45h55.56l-2.58-5.45z",
    style: {
      fill: "#1b0f49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.92 213.45h8.51v5.45h-8.51z",
    style: {
      fill: "#352269"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.09 214.61h5.95v3.06h-5.95z",
    style: {
      fill: "#1b0f49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467.73 213.45 1.85-51.78-1.5-5.75-9 1.42s5.06 20.14 6.16 23.9c.9 3.09.32 24.58.09 32.21Z",
    style: {
      fill: "#c4b7fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.43 201.18c.44 5.78-33.68 34.32-36.59 35.67s-5.61.07-5.22-2.42c.56-3.54 22.84-32.8 27.62-39.24s13.34-5.19 14.19 5.99",
    style: {
      fill: "#ffa49e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 179.29s-2.27 6.3-15.07 7.43c0 0-18-28.31-20.75-34.22-2.21-4.77-3.69-17.77 8.7-17.71s23.2 31.51 27.12 44.5",
    style: {
      fill: "#dfd8ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.18 98.59s-1.24 4.7 1.22 6 3.86 3 3.46 4.22 4.21 8 8.42 8 .16-2.6 4-4.77c3.33-1.89 2.24-14.55-1.85-16.93s-5.64-9.17-13.25-8-8.51 6.89-14.37 5.39-7.47 13.74.37 12.55c0 0 .57-2.43 1.26-2.09 2.44 1.24 6.42 3.46 10.74-4.37",
    style: {
      fill: "#ee4b5d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 440.46,
    cy: 107.74,
    r: 2.28,
    style: {
      fill: "#ffa49e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.78 116.74c.3-1.57-2.22-2.22-3.17-1.28a1.11 1.11 0 0 0-.34 1 .3.3 0 0 0 .07.16.4.4 0 0 0 .16.07",
    style: {
      fill: "#f6f8fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456.46 407.18.85 6.77h9.98l.11-6.77z",
    style: {
      fill: "#dfd8ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 412.76s4.12 1.48 10.42 0l-.39 8.59h-27.62s-1.52-2 2.9-3.33c7.69-2.4 14.69-5.26 14.69-5.26M457 412.76s4.13 1.48 10.43 0l.74 8.59h-28.8s-1.51-2 2.91-3.33c7.72-2.4 14.72-5.26 14.72-5.26",
    style: {
      fill: "#352269"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.2 140.56 3.2 4.39 11.73-6.34 1.87-4.11-1.61-2.27s-10.31 6.77-15.19 8.33",
    style: {
      fill: "#c4b7fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.2 140.56-2.76 4.39 4.86-1.51z",
    style: {
      fill: "#dfd8ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.13 140.56-5.1 1.5 3.54-4.45 3.55-4.45-.38 1.28z",
    style: {
      fill: "#c4b7fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.65 144.18s-1.64 9.28-2.37 18.67 0 50.83 0 50.83",
    style: {
      fill: "none",
      stroke: "#c4b7fb",
      strokeMiterlimit: 10,
      strokeWidth: ".389170497655869px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.73 222.37s4.51 18.22 13.51 19M418.13 221.35a56 56 0 0 1-3 6.24",
    style: {
      fill: "none",
      stroke: "#1b0f49",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.55668199062347px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 426.66,
    cy: 169.22,
    rx: 0.57,
    ry: 1.15,
    style: {
      fill: "#c4b7fb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 426.66,
    cy: 178.93,
    rx: 0.57,
    ry: 1.15,
    style: {
      fill: "#c4b7fb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 426.66,
    cy: 188.63,
    rx: 0.57,
    ry: 1.15,
    style: {
      fill: "#c4b7fb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 426.66,
    cy: 198.34,
    rx: 0.57,
    ry: 1.15,
    style: {
      fill: "#c4b7fb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 426.66,
    cy: 208.04,
    rx: 0.57,
    ry: 1.15,
    style: {
      fill: "#c4b7fb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 426.66,
    cy: 159.4,
    rx: 0.57,
    ry: 1.15,
    style: {
      fill: "#c4b7fb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.81,
    cy: 151.34,
    rx: 1.15,
    ry: 0.57,
    style: {
      fill: "#c4b7fb"
    },
    transform: "rotate(-76.8 427.795 151.336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389 412.76.74-5.6H401l-1.73 6.15s-7.27 1.85-10.27-.55",
    style: {
      fill: "#dfd8ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.68 414.82s.19-4.37 1.59-3.58-1.59 3.58-1.59 3.58ZM449.63 412.76c.68-.52 2.05 2.06 2.05 2.06s-3.33-1.08-2.05-2.06ZM384.39 414.82s.19-4.37 1.59-3.58-1.59 3.58-1.59 3.58ZM382.33 412.76c.69-.52 2.06 2.06 2.06 2.06s-3.33-1.08-2.06-2.06Z",
    style: {
      fill: "none",
      stroke: "#352269",
      strokeMiterlimit: 10,
      strokeWidth: ".389170497655869px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.66 142.06s-2.81-2.9-3-4.69a1.48 1.48 0 0 1 1.4-1.82s-2.32-5.84 1.19-4c0 0 1-2.11 2.2-.77 0 0 1.32-1.48 2.17 0a1.7 1.7 0 0 1 2.2 1.34c.31 1.29 1.51 5.89 2.3 9.3.35 1.52.4 1.32 1.88 4 0 0-5.73 5.24-6.41 2.48-.88-3.47-3.24-4.82-3.93-5.84",
    style: {
      fill: "#ffa49e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.89 120.75c-.2 2.5.66 13.74-1.21 20-3.62 12.16 4.17 20.49 9.74 24s6.92-19.47 6.92-19.47l-11.09-33.18Z",
    style: {
      fill: "#352269"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m494.22 203.72-8.05 71.62s4.67 2 5.77-.27c1.56-3.23 17.25-56.75 17-64.77s-14.72-6.58-14.72-6.58",
    style: {
      fill: "#b77e7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.39 222.45h-3.28l2.67-27.75 8.19 10.86z",
    style: {
      fill: "#1395e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510 159.61s3.28 2-1.24.06a1.41 1.41 0 0 1-.61-1.53c0-.13.05-.28.08-.44 1.24-7.34-5.37-11.74-5.24-19.28.16-9.67 5.56-20.6 6-24.25l16.57 18.37L540 151.15a28.4 28.4 0 0 1 1.38 4.85c-.16.34-.12 3.3-15.4 3.61",
    style: {
      fill: "#1b0f49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m515.34 211.42 27.51 216.46h11.26s-6.79-153.54-7.38-170.23.55-32.13-8.3-46.23z",
    style: {
      fill: "#b77e7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m538.42 211.42-45.61 217.01h-10.34l13.62-217.01z",
    style: {
      fill: "#b77e7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.43 211.42h-42.34s-7.9-31.44-6.72-34.32l7.51-23.19a7.12 7.12 0 0 1 6.59-4.42h37.65a7.12 7.12 0 0 1 7.09 7.84Z",
    style: {
      fill: "#80c9ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.94 152.18a3.54 3.54 0 0 0 .74-3.71c-.91-2.43-1.89-7.31 0-15.41 2.91-12.44 1.45-23.28-12.29-27.64-12.22-3.88-15.74 18.7-12.51 28.75a7.17 7.17 0 0 0 3.74 4.18l1.31.63a3.92 3.92 0 0 1 2.36 3.25c.18 2.43.22 6.27-1 8.15-1.94 2.89-6.31 5.32-3.07 10.17 3.02 4.59 10.58 1.96 20.72-8.37",
    style: {
      fill: "#b77e7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.07 108.82a8.85 8.85 0 0 0 2 8.21c1.62 1.85 5.26-3.07 8.81 4.76a61 61 0 0 0 2 12.16c3.94 12.47 16.91 15.71 20 15.6s15.71 21.84 15.45 19c4.12-.36 3.62-26-16.69-34.19-9.18-3.7-5.47-23.69-18.85-29.32-8.08-3.36-13.18 1.59-12.72 3.78",
    style: {
      fill: "#352269"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 517.61,
    cy: 122.86,
    r: 2.28,
    style: {
      fill: "#b77e7d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 502.45,
    cy: 122.65,
    rx: 0.68,
    ry: 1.18,
    style: {
      fill: "#352269"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 510.48,
    cy: 123.32,
    rx: 0.68,
    ry: 1.18,
    style: {
      fill: "#352269"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.59 123.75a4.74 4.74 0 0 1-.33 2.08c-.14.26-.32.5-.45.77a2.38 2.38 0 0 0-.21 1.51",
    style: {
      fill: "none",
      stroke: "#843d3d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".6000000000000001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.68 131.49a1.45 1.45 0 0 1 1.63-1 3 3 0 0 1 1.76 1.07 13.3 13.3 0 0 1-3.39-.07",
    style: {
      fill: "#843d3d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 108.13a10.88 10.88 0 0 1-2.31 8.05 18 18 0 0 1-4.78 4.57s-1.73-7.84 1.62-11.09 4.32-2.81 5.47-1.53M538.42 211.42l-39.86 201.73h-15.29l12.82-201.73z",
    style: {
      fill: "#352269"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.71 255.52-31.15 157.63h-.37l19.9-180.74z",
    style: {
      fill: "#1b0f49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m509 211.42 30.56 203.92 15.07.2s-2.63-141.2-3.23-157.89-4.12-32.13-13-46.23z",
    style: {
      fill: "#352269"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m554.61 415.54-.41-8.6h-18.61l3.95 8.4zM498.56 413.15l3.8-9.05h-19.09v9.05z",
    style: {
      fill: "#453287"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m534.83 160.42 12.67 56.07s16 3.46 15.63-.22-9.64-45.74-11.35-55.67c-2.48-14.37-19.54-15.49-16.95-.18",
    style: {
      fill: "#b77e7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m544.11 180.01-5.69 31.41h-1.78l4.75-41.79z",
    style: {
      fill: "#1395e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.32 215.7s-6 61.25-6.85 64.35c-.88 3.37 4.57 3.25 5.67 1 1.56-3.23 17.24-56.76 17-64.77s-15.82-.58-15.82-.58",
    style: {
      fill: "#b77e7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.47 280.05s-7.89 11.18-5.94 10.89 3.4-4.08 4.32-1.83c2.49 6.14 3.26 11.19 4.3 10.4a6.1 6.1 0 0 0 0-1.92 3.6 3.6 0 0 0 1.24 1.9c1 .69.14-3.83.14-3.83s.49 2.67 1.25 2.5a7.3 7.3 0 0 0 0-2.13s.2.68.71.62-1.45-5.83-1.47-7.59.62-7.19 1.13-8-5.68-1.01-5.68-1.01",
    style: {
      fill: "#b77e7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.13 216.27s-2.8.87-15.63.22c0 0-11-45.15-12.23-50.53-.83-3.69-3.56-12.9-.71-16.47a39 39 0 0 1 8.21.07c15.72 2.22 18.23 53.31 20.36 66.71",
    style: {
      fill: "#80c9ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m554.11 427.88 2.33 8.58H528.9s-1.86-.93 4.41-3.35 10.13-3.43 9.54-5.23ZM493 427.88l-.39 8.58H466.5s-1.86-.93 4.4-3.35 11.49-3.51 11.64-5.23",
    style: {
      fill: "#b77e7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m544.71 433.34 8-3.67h1.83l1.85 6.79H528.9s-1.86-.93 4.41-3.35c3.94-1.52 6.93-2.48 8.46-3.44h2.94ZM483.17 433.34l8.05-3.67h1.83l.81 6.79h-27.73s-1.86-.93 4.4-3.35c3.94-1.52 8.17-2.48 9.7-3.44h2.94Z",
    style: {
      fill: "#ee4b5d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m538.43 211.42 4 6.54c-.16-.28-47.23 0-47.23 0l.92-6.54Z",
    style: {
      fill: "#1b0f49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.24 218s4.5 18.23 13.51 19",
    style: {
      fill: "none",
      stroke: "#1b0f49",
      strokeMiterlimit: 10,
      strokeWidth: "1.55668199062347px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.66 120.34s2.5-2.79 4.67 1.13M501.49 120.64a3 3 0 0 0 2.19 0",
    style: {
      fill: "none",
      stroke: "#843d3d",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.48 272.85s5.86 13.2 4 12.58-3.79-5-3.93-2.55c-.18 3.17-.18 11.23-1.07 10.27 0 0-2.33-4.47-2.51-6.22-.39-3.89-1.87-8.46-1.78-11.59.01-.97 5.29-2.49 5.29-2.49",
    style: {
      fill: "#b77e7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.81,
    cy: 224.75,
    r: 6.23,
    style: {
      fill: "none",
      stroke: "#ce414d",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.64859143580998px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.87,
    height: 46.33,
    x: 137.53,
    y: 70.74,
    rx: 14.93,
    style: {
      fill: "#1b0f49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.52 91.55h41.96v4.71h-41.96zM181.08 131.07h-25.16v-4.71h25.16z",
    style: {
      fill: "#352269"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.66 126.36h-24.31l-6.79-30.1h37.88z",
    style: {
      fill: "#dfd8ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.48 91.55-6-5.12a23.09 23.09 0 0 0-29.86 0l-6 5.12ZM155.92 131.07l3.63 3.08a13.86 13.86 0 0 0 17.9 0l3.63-3.08Z",
    style: {
      fill: "#352269"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.56 96.26 6.79 30.1h6.13l-4.56-30.1z",
    style: {
      fill: "#c4b7fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.5 96.26v32.46",
    style: {
      fill: "none",
      stroke: "#352269",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.25,
    cy: 46.39,
    r: 37.35,
    style: {
      fill: "none",
      stroke: "#ffb4bc",
      strokeMiterlimit: 10,
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.18,
    cy: 192.22,
    r: 29.06,
    style: {
      fill: "none",
      stroke: "#ffb4bc",
      strokeMiterlimit: 10,
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 613.67,
    cy: 310.59,
    r: 15.07,
    style: {
      fill: "none",
      stroke: "#ffb4bc",
      strokeMiterlimit: 10,
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.88,
    cy: 231.02,
    r: 6.21,
    style: {
      fill: "#ffe4e5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 556.44,
    cy: 63.11,
    r: 6.21,
    style: {
      fill: "#ffe4e5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.52,
    cy: 41.9,
    r: 10.51,
    style: {
      fill: "#ffe4e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 327.55",
    style: {
      fill: "#ffc40a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.71 335c4.93 0 8-1.94 8.92-3.72.78-1.57-2.91-3.22-6.82-3.61 14.38 1.08 23.42 12.43 26.73 26.71 3.7 16 10.65 49.73-.48 61.95a15.05 15.05 0 0 1-11 5.22H159.7a15.05 15.05 0 0 1-11-5.22c-11.13-12.22-4.18-46-.48-61.95 3.31-14.28 12.34-25.63 26.73-26.71-3.91.39-6.82 1.86-6.82 3.61 0 2.06 4 3.72 8.92 3.72Z",
    style: {
      fill: "#ff6979"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 177.01,
    cy: 331.27,
    rx: 8.92,
    ry: 3.72,
    style: {
      fill: "#ee4b5d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.36 334.85s4.51-60.3 27.53-95.47a1.06 1.06 0 0 1 1.93.41c1.29 7.56 3.69 31.45-10 61.31-16.65 36.34-15.2 33.29-15.2 33.29s.38 1.02-4.26.46M170.81 332.93s1.13-15.64-8.65-35.19c-9.61-19.22-16.27-52-9.5-85.38a.72.72 0 0 1 1.3-.27c4.49 6.76 23.18 37.79 21 83.51 0 0-1.06 30.29 2.37 38.68.03 0-4.09.43-6.52-1.35",
    style: {
      fill: "#1395e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.49 316.69c-7.4-20.19-26.72-47.54-55.62-65.48a.72.72 0 0 0-1.09.76c1.84 7.9 11.61 42.79 46.35 72.58 0 0 17.87 12.65 10.36-7.86",
    style: {
      fill: "#1395e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.78 252s33.14 60.2 52.64 69.75M154 212.09s24 70.51 17.37 109.63M206.82 239.79s-16 36.29-22.77 85.71",
    style: {
      fill: "none",
      stroke: "#0075c9",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".600000023841858px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.57 333.15s12.39-7 15.69-20.14 16.74-44.89 48.2-51.91c0 0-12.15 28.09-32.34 47.94s-21.49 25.35-21.49 25.35-7.72 1.27-10.06-1.24",
    style: {
      fill: "#80c9ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.78 291c2.67 29.94 5.63 38.38 3.09 44.55 0 0-.78-.22 3.49-.69 0 0 2.77-23.06 10.89-39.86 7.3-15.1 3.34-61.09 2.47-70.19a.66.66 0 0 0-1.17-.34c-4.47 5.62-22.01 30.25-18.77 66.53",
    style: {
      fill: "#80c9ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.36 334.85s-2.75-59.4-30.65-82.92c0 0-7.48 26.59 6.9 48.87s20.26 34.74 20.26 34.74Z",
    style: {
      fill: "#80c9ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.71 252.93s3.19 48.46 28.56 68.79M190.72 224.8s-1.51 69.76-14.07 102.76M235.46 261.1s-35.46 27.24-55.65 66.56",
    style: {
      fill: "none",
      stroke: "#1395e5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".600000023841858px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.6 333.5s-25.3-3.75-38.38-24.9c0 0 25.7-6.55 45.15 26.21 0 0-2.53 1.89-6.77-1.31",
    style: {
      fill: "#f0fbff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.4 299.63a58 58 0 0 0-39.86 17.86c-17.53 18.37-14.06 15.28-14.06 15.28l2.88 2.08s39.8-9.38 51.04-35.22",
    style: {
      fill: "#f0fbff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.39 273.83s-8.21 23.85 3.55 46.36l10.49 15.35 2.9-2.05s3.92-40.7-16.94-59.66",
    style: {
      fill: "#f0fbff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.39 273.83s16.61 41.46 13.68 61c-17.44-6.44-43.85-26.25-43.85-26.25",
    style: {
      fill: "none",
      stroke: "#c9e4f4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".600000023841858px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.66 326s1.73-23.79 19.7-37.26c0 0 8.34 26.29-19.56 46.4 0 0-2.71-5-.14-9.14",
    style: {
      fill: "#f0fbff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.36 288.72s-4.92 30.48-19.29 46.13c0 0 42.89-16.34 53.33-35.22",
    style: {
      fill: "none",
      stroke: "#c9e4f4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".600000023841858px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.84 333.28a30 30 0 0 1-7.77.88 38.3 38.3 0 0 1-7.77-1.11c-.46.6-.72.83-.72 1.44 0 1.64 3.8 3 8.49 3s8.12-.87 8.51-2.47a1.34 1.34 0 0 0-.74-1.74",
    style: {
      fill: "#ee4b5d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.06 176.9-7.53 12.51M302.64 173l-16.17 26.87M354.53 176.9 347 189.41M364.11 173l-16.17 26.87",
    style: {
      fill: "none",
      stroke: "#9173ad",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.39 380.93c-1.55 13.93-1.19 28.29 5.27 35.39a15.05 15.05 0 0 0 11 5.22h32.35c-17.76-3.64-40.5-13.82-48.62-40.61",
    style: {
      fill: "#ee4b5d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.06 364.17c-2.16 10.82-4.19 24.54-3.17 35.78a200.6 200.6 0 0 0 69-.14l.15-2.1c.59-10.8-1.32-23.46-3.34-33.58-17.56 1.72-44.9 1.73-62.64.04",
    style: {
      fill: "#ffb4bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.39 380.93a97 97 0 0 0-.49 19c4 .7 7.94 1.26 11.94 1.7a54.5 54.5 0 0 1-11.45-20.7",
    style: {
      fill: "#ff9ba5"
    }
  })));
};
export default Svg404V2;